<template>
    <!-- <div class="resource-booking-popup modal in" tabindex="-1" role="dialog" style="display:block;"> -->

    <b-modal id="resource-booking-popup"
        ref="resourceBookingPopup"
        v-model="bookingModalIsOpen"
        size="xl"
        centered

        footerClass='justify-content-center'
        :hide-header="false"
        :hide-footer="false"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        :hide-header-close="true" >

        <template v-slot:modal-header>
            <h5 class="modal-title text-center font-weight-bold">Prenota la tua prestazione</h5>
        </template>

        <div class="default">
            <form>
                <div class="row">
                    <div class="col-xl-6">
                        <div class="form-row">
                            <div class="form-group col-sm-4">
                                <label for="first_name" class="d-none d-lg-block">{{ $t('user.first_name') }} <span class="text-danger">*</span></label>
                                <input id="first_name" type="text" class="form-control" name="first_name" :placeholder="$t('user.first_name')" v-model="user.first_name" required autocomplete="given-name">
                                <div class="text-danger" role="alert" v-if="validation.hasError('user.first_name')">{{ validation.firstError('user.first_name') }}</div>
                            </div>
                            <div class="form-group col-sm-4">
                                <label for="middle_name" class="d-none d-lg-block">{{ $t('user.middle_name') }}</label>
                                <input id="middle_name" type="text" class="form-control" name="middle_name" :placeholder="$t('user.middle_name')" v-model="user.middle_name" autocomplete="additional-name">
                            </div>
                            <div class="form-group col-sm-4">
                                <label for="last_name" class="d-none d-lg-block">{{ $t('user.last_name') }} <span class="text-danger">*</span></label>
                                <input id="last_name" type="text" class="form-control" name="last_name" :placeholder="$t('user.last_name')" v-model="user.last_name" required autocomplete="family-name">
                                <div class="text-danger" role="alert" v-if="validation.hasError('user.last_name')">{{ validation.firstError('user.last_name') }}</div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-sm-6">
                                <label for="national_identification_number" class="d-none d-lg-block">{{ $t('user.national_identification_number') }} <span class="text-danger">*</span></label>
                                <input id="national_identification_number" type="text" class="form-control" name="national_identification_number" :placeholder="$t('user.national_identification_number')" v-model="user.national_identification_number" required autocomplete="on">
                                <div class="text-danger" role="alert" v-if="validation.hasError('user.national_identification_number')">{{ validation.firstError('user.national_identification_number') }}</div>
                            </div>
                            <div class="form-group col-sm-6">
                                <label for="vat_code" class="d-none d-lg-block">{{ $t('user.vat_code') }}</label>
                                <input id="vat_code" type="text" class="form-control" name="vat_code" :placeholder="$t('user.vat_code')" v-model="user.vat_code" autocomplete="on">
                            </div>
                        </div>

                        <div class="form-row mt-3 d-none d-lg-block"></div>

                        <div class="form-row">
                            <div class="form-group col-sm-8">
                                <label for="address" class="d-none d-lg-block">{{ $t('user.address') }} <span class="text-danger">*</span></label>
                                <input id="address" type="text" class="form-control" name="address" :placeholder="$t('user.address')" v-model="user.address" required autocomplete="street-address">
                                <div class="text-danger" role="alert" v-if="validation.hasError('user.address')">{{ validation.firstError('user.address') }}</div>
                            </div>
                            <div class="form-group col-sm-4">
                                <label for="postal_code" class="d-none d-lg-block">{{ $t('user.postal_code') }} <span class="text-danger">*</span></label>
                                <input id="postal_code" type="text" class="form-control" name="postal_code" :placeholder="$t('user.postal_code')" v-model="user.postal_code" required autocomplete="postal-code">
                                <div class="text-danger" role="alert" v-if="validation.hasError('user.postal_code')">{{ validation.firstError('user.postal_code') }}</div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-sm-4">
                                <label for="country_code" class="d-none d-lg-block">{{ $t('user.country') }} <span class="text-danger">*</span></label>
                                <select id="country_code" class="form-control" name="country_code" :placeholder="$t('user.country')" v-model="user.country_code" required>
                                    <option v-for="country in countries" v-bind:value="country.isoCode" v-bind:key="country.isoCode">
                                        {{ country.name }}
                                    </option>
                                </select>
                                <div class="text-danger" role="alert" v-if="validation.hasError('user.country_code')">{{ validation.firstError('user.country_code') }}</div>
                            </div>
                            <div class="form-group col-sm-4">
                                <label for="area" class="d-none d-lg-block">{{ $t('user.area') }} <span class="text-danger">*</span></label>
                                <input id="area" type="text" class="form-control" name="area" :placeholder="$t('user.area')" v-model="user.area" required autocomplete="off">
                                <div class="text-danger" role="alert" v-if="validation.hasError('user.area')">{{ validation.firstError('user.area') }}</div>
                            </div>
                            <div class="form-group col-sm-4">
                                <label for="city" class="d-none d-lg-block">{{ $t('user.city') }} <span class="text-danger">*</span></label>
                                <input id="city" type="text" class="form-control" name="city" :placeholder="$t('user.city')" v-model="user.city" required autocomplete="off">
                                <div class="text-danger" role="alert" v-if="validation.hasError('user.city')">{{ validation.firstError('user.city') }}</div>
                            </div>
                        </div>

                        <div class="form-row mt-3 d-none d-lg-block"></div>

                        <div class="form-row">
                            <div class="form-group col-sm-6">
                                <label for="phone_mobile" class="d-none d-lg-block">{{ $t('user.phone_mobile') }} <span class="text-danger">*</span></label>
                                <vue-tel-input
                                    v-model="user.phone_mobile"
                                    required
                                    class="form-control"
                                    autocomplete="tel"
                                    :inputOptions="{
                                        placeholder: this.$t('user.phone_mobile'),
                                        id: 'phone_mobile',
                                        name: 'phone_mobile',
                                    }"
                                    mode="international"></vue-tel-input>
                                <div class="text-danger" role="alert" v-if="validation.hasError('user.phone_mobile')">{{ validation.firstError('user.phone_mobile') }}</div>
                            </div>
                            <div class="form-group col-sm-6">
                                <label for="phone_home" class="d-none d-lg-block">{{ $t('user.phone_home') }}</label>
                                <vue-tel-input
                                    v-model="user.phone_home"
                                    class="form-control"
                                    autocomplete="off"
                                    :inputOptions="{
                                        placeholder: this.$t('user.phone_home'),
                                        id: 'phone_home',
                                        name: 'phone_home',
                                    }"
                                    mode="international"></vue-tel-input>
                                <div class="text-danger" role="alert" v-if="validation.hasError('user.phone_home')">{{ validation.firstError('user.phone_home') }}</div>
                            </div>
                        </div>

                        <hr class="mt-2 mb-4"/>

                        <div class="form-group">
                            <label for="notes" class="d-none d-lg-block">{{ $t('user.note') }}</label>
                            <textarea class="form-control" id="notes" :placeholder="$t('user.note')" rows="3" v-model="notes" maxlength="2000"></textarea>
                        </div>

                        <div style="overflow:hidden; position:relative;">
                            <div id="anchorEndOfForm" ref="anchorEndOfForm" style="position:absolute;top:300px;"></div>
                        </div>
                    </div>

                    <div class="col-xl-6 order-first order-xl-last">
                        <div class="alert alert-info">
                            <div class="form-group row" v-if="resource">
                                <div class="col-2 pr-2 text-center">
                                    <img class="card-img rounded" :src="getImageSrc" />
                                </div>
                                <div class="col-10 pl-2">
                                    <h5 pb-0>{{ resource.name }}</h5>
                                    <h6>{{ resource.title ? `Specializzazione in ${resource.title}` : '' }}</h6>
                                </div>
                            </div>
                            <hr />
                            <div class="form-group row mb-1">
                                <div class="col-2 pr-2 text-center">
                                    <i class="far fa-map-marker-alt" style="font-size:1.5em;"></i>
                                </div>
                                <div class="col-10 pl-2">
                                    <div v-if="headquarter">{{ headquarter.name }}<br/>{{ headquarter.address }} - {{ headquarter.city }} ({{ headquarter.area_code }})</div>
                                </div>
                            </div>
                            <hr />
                            <div class="form-group row" v-if="bookDateTime">
                                <div class="col-2 pr-2 text-center">
                                    <i class="far fa-calendar-alt" style="font-size:1.5em;"></i>
                                </div>
                                <div class="col-10 pl-2">
                                    <div>{{ bookDateTime | moment("dddd DD MMMM YYYY") | capitalize }}</div>
                                </div>
                            </div>
                            <hr />
                            <div class="form-group row" v-if="bookDateTime">
                                <div class="col-2 pr-2 text-center">
                                    <i class="far fa-clock" style="font-size:1.5em;"></i>
                                </div>
                                <div class="col-10 pl-2">
                                    <div>{{ bookDateTime | moment("HH:mm") }}</div>
                                </div>
                            </div>
                            <hr />
                            <div class="form-group row mb-1" v-if="service">
                                <div class="col-2 pr-2 text-center">
                                    <i class="far fa-stethoscope" style="font-size:1.5em;" alt="Prestazione"></i>
                                </div>
                                <div class="col-10 pl-2">
                                    <!--
                                    <select id="serviceId" class="form-control">
                                        <option :value="service.id"> {{ service.name }} ({{ service.price }} €) - {{ service.duration }} min</option>
                                    </select>
                                    -->
                                    <!--
                                    <select id="serviceId" class="form-control" @change="serviceIdOnChange">
                                        <option v-for="currentService in resourceServicesSelectOptions" :value="currentService.id" :selected="currentService.id == service.id" :key="currentService.id" :disabled="maxSlotDuration && currentService.duration > maxSlotDuration">
                                            {{ currentService.name }} ({{ currentService.price }} €) - {{ currentService.duration }} min
                                        </option>
                                    </select>
                                    -->
                                    <multiselect id="serviceId"
                                        v-model="selectedService"
                                        v-on:input="serviceIdOnChange"
                                        :options="resourceServicesSelectOptions"
                                        :placeholder="'Seleziona una voce'"
                                        :show-labels="false"
                                        :allow-empty="false"
                                        :style="{ marginTop: '-10px' }"
                                        track-by="id"
                                        label="name"
                                    >
                                        <template slot="singleLabel" slot-scope="props">
                                            <span class="option__desc">
                                                <span class="option__title">
                                                    {{ props.option.name }} ({{ props.option.price }}€{{ (props.option.vatRate > 0 ? " IVA Inc." : "") }}) <span v-if="!serverSettings.hideServiceDuration">- {{ props.option.duration }} min</span>
                                                </span>
                                            </span>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <span class="option__title" v-html="serviceOptionContent(props.option)">
                                                </span>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <div class="form-group mb-0" v-if="service && service.description" style="white-space: pre-wrap;">{{ service.description }}</div>
                                </div>
                            </div>

                            <hr />
                            <div class="form-group row mb-1">
                                <div class="col-2 pr-2 text-center">
                                    <i class="far fa-money-bill-wave" style="font-size:1.5em;" alt="Note di preparazione"></i>
                                </div>
                                <div class="col-10 pl-2">
                                    <div style="white-space: pre-wrap;" v-html="getBookingPaymentWarning"></div>
                                </div>
                            </div>

                            <hr v-if="service && service.additionalInfo" />
                            <div class="form-group row mb-1" v-if="service && service.additionalInfo">
                                <div class="col-2 pr-2 text-center">
                                    <i class="far fa-notes-medical" style="font-size:1.5em;" alt="Note di preparazione"></i>
                                </div>
                                <div class="col-10 pl-2">
                                    <div style="white-space: pre-wrap;"><b>Note di preparazione:</b><br/>{{ service.additionalInfo }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </form>
        </div>
        <template v-slot:modal-footer>
            <div>
                <b-button v-on:click="confirmBooking" variant="primary">{{ getBookingButtonLabel }}</b-button>
            </div>
            <div>
                <b-button v-on:click="cancelBooking" variant="default">Annulla</b-button>
            </div>
        </template>
    </b-modal>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
#resource-booking-popup {
    .modal-dialog {
        width: 100vw;
        height: 100vh;
        margin: 0;
        padding: 0;
        max-width: none;
    }
    .modal-content {
        height: auto;
        height: 100vh;
        border-radius: 0;
        border: none;
    }
    .modal-body {
        overflow-y: auto;
        overflow-x: hidden;
    }
}
</style>

<script>
import Multiselect from 'vue-multiselect';
import VueTypes from 'vue-types'

export default {
    components: {
        Multiselect,
    },
    data() {
        return {
            notes: null,
            selectedService: null,
        };
    },
    props: {
        serverSettings: VueTypes.object,
        instanceId: VueTypes.number.def(undefined),
        headquarter: VueTypes.object,
        countries: VueTypes.array,
        bookDateTime: VueTypes.string,
        maxSlotDuration: VueTypes.number,
        user: VueTypes.object,
        resource: VueTypes.object,
        service: VueTypes.object,
        resourceServices: VueTypes.object,
        // presences: VueTypes.array,
        // notes: VueTypes.string,
    },
    validators: {
        "user.first_name": function (value) {
            return this.$validator.value(value || '').required();
        },
        "user.last_name": function (value) {
            return this.$validator.value(value || '').required();
        },
        "user.national_identification_number": function (value) {
            return this.$validator.value(value || '').required();
        },
        "user.address": function (value) {
            return this.$validator.value(value || '').required();
        },
        "user.postal_code": function (value) {
            return this.$validator.value(value || '').required();
        },
        "user.country_code": function (value) {
            return this.$validator.value(value || '').required();
        },
        "user.area": function (value) {
            return this.$validator.value(value || '').required();
        },
        "user.city": function (value) {
            return this.$validator.value(value || '').required();
        },
        "user.phone_mobile": function (value) {
            return this.$validator.value(value || '').required();
        },
        "user.phone_home": function (value) {
            return this.$validator.value(value || '');
        },
    },
    computed: {
        resourceServicesSelectOptions() {
            let options = Object.values(this.resourceServices);
            options.sort((a, b) => a.name.localeCompare(b.name));

            // Disabilita le opzioni che hanno una durata superiore alla durata massima
            options.forEach((option) => {
                option.$isDisabled = this.maxSlotDuration && option.duration > this.maxSlotDuration;
            });

            return options;
        },
        getImageSrc() {
            return (this.resource && this.resource.imageUrl) || defaultProfileImage;
        },
        getBookingButtonLabel() {
            if (this.service && this.service.bookingPrice > 0) {
                return "Vai al pagamento sicuro";
            } else {
                return "Conferma prenotazione";
            }
        },
        getBookingPaymentWarning() {
            let text = "";
            if (this.service) {
                if (this.service.bookingPrice > 0) {
                    if (this.service.bookingPrice != this.service.price) {
                        text = "Per effettuare questa prenotazione è richiesto il pagamento di una caparra confirmatoria di <b>" + this.service.bookingPrice + "€</b>.";
                        text+= "\nL'importo restante di <b>" + (this.service.price - this.service.bookingPrice) + "€</b> verrà saldato in sede";
                    } else {
                        text = "Per effettuare questa prenotazione è richiesto il pagamento anticipato di <b>" + this.service.bookingPrice + "€</b>.";
                    }
                } else {
                    text = "L'intero importo di <b>" + (this.service.price - this.service.bookingPrice) + "€</b> verrà saldato in sede";
                }
            }
            return text;
        },
        bookingModalIsOpen: {
            get() {
                if (this.bookDateTime) {
                    return true;
                }
                return false;
            },
            set(value) {
                // Richiesto per evitare errore alla chiusura del modal premendo il tasto esc
            }
        },
    },
    filters: {
        properCase(string) {
            if (typeof string == "string") {
                return string.charAt(0).toUpperCase() + string.slice(1);
            } else {
                return "";
            }
        },
    },
    methods: {
        serviceOptionContent(option) {
            let durationText = ""
            if (!this.serverSettings.hideServiceDuration) {
                durationText = "- <span class='"+(this.maxSlotDuration && option.duration > this.maxSlotDuration ? 'text-danger' : '')+"'>" + option.duration + " min</span>";
            }

            return option.name + " (" + option.price + "€"+ (option.vatRate > 0 ? " IVA Inc." : "") +") " +
                durationText + (
                    (this.maxSlotDuration && option.duration > this.maxSlotDuration) ?
                        " <span class='text-danger'>(disponibilità medico insufficiente, cambiare data)</span>" :
                        ""
                );
        },
        serviceIdOnChange(service) {
            this.$emit('setServiceById', service.id);
        },
        scrollToEndOfForm() {
            this.$nextTick(() => {
                // setTimeout is needed to wait for the DOM to be updated
                setTimeout(() => {
                    this.$refs.anchorEndOfForm.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                    });
                }, 1);
            });
        },
        confirmBooking() {
            if (!stripe_public_key) {
                this.$snotify.error("Stripe public key not set");
                return;
            }

            this.$validate()
                .then((success) => {
                    if (success) {
                        this.executeBooking();
                    } else {
                        this.$snotify.error("Uno o più campi non sono validi");
                    }
                });

        },
        executeBooking() {
            if (!this.headquarter) {
                alert("Sede di prenotazione non valida, la pagina verrà ricaricata");
                location.reload();
                return;
            }

            this.$emit('setLoadingBookingDialog', true);

            let params = {
                instance_id: this.instanceId,
                headquarter_id: this.headquarter.id,
                resource_id: this.resource.id,
                service_id: this.service.id,
                book_date_time: this.bookDateTime,
                notes: this.notes,
                user: this.user,
            };

            // let queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
            // window.location.href = "/checkout?" + queryString;
            axiosOnce({
                    method: "get",
                    url: baseUrl+"/checkout",
                    crossDomain: false,
                    withCredentials: true,
                    params: params,
                }, 'executeBooking')
                .then(({ data }) => {
                    if (typeof data != "object") {
                        throw "Errore di comunicazione con il server";
                    } else if (data.redirect_to) {
                        // this.$emit('setBookingPopupData', null);
                        // this.$emit('setLoadingBookingDialog', false);

                        window.location.href = data.redirect_to;
                        return;
                    } else if (parseFloat(data.amount) <= 0) {
                        throw "Impossibile processare un pagamento ad importo 0";
                    } else if (!data.payment_intent_id) {
                        throw "Impossibile processare i dati del pagamento";
                    }

                    let stripeClientSecret = data.client_secret;
                    if (!stripeClientSecret) {
                        throw "Impossibile leggere il codice della transazione";
                    }
                    this.$emit('setLoadingBookingDialog', false);
                    this.openCheckoutDialog(stripeClientSecret);
                })
                .catch(error => {
                    this.$emit('setLoadingBookingDialog', false);

                    if (axios.isCancel(error)) {
                        console.log('Request canceled', error.message);
                        return;
                    } else if (error.code === 'ECONNABORTED') {
                        return;
                    }

                    console.log("error", error);
                    console.log("error.response", error.response);

                    // Gestione errori speciali che richiedono redirect
                    var specialExceptions = [
                        "App\\Exceptions\\SafeModeBlockException",
                    ];
                    if (error && error.response && (!error.response.data || !specialExceptions.includes(error.response.data.exception))) {
                        if (error.response.status === 401) {
                            alert("Per prenotare è necessario essere autenticati");
                            window.location.href = "/login";
                            return;
                        } else if (error.response.status === 403) {
                            // TODO: Anzichè fare un redirect, mostrare un popup col form dei dati di fatturazione in modo da non interrompere l'utente (non dovrebbe più capitare)
                            alert(error.response.data.message);
                            // window.location.href = "/profile";
                            return;
                        }
                    }

                    let errorMessage = "Errore sconosciuto";
                    if (error && error.response) {
                        if (error.response.data.errors) {
                            errorMessage = "Uno o più campi non sono validi";
                            for (let fieldName in error.response.data.errors) {
                                let fieldError = error.response.data.errors[fieldName];
                                this.validation.addError("user."+fieldName, fieldError.join(', '));
                            }
                        } else {
                            errorMessage = error.response.data.message;
                        }
                    } else if (error) {
                        errorMessage = error;
                    }

                    // Durata dinamica del popup
                    var dynamicTimeout = 6000;
                    let textWords = errorMessage.split(' ').length;
                    dynamicTimeout = Math.max(dynamicTimeout, textWords * 250);

                    console.log("SNOTIFY ERROR", errorMessage);
                    this.$snotify.error(errorMessage, {
                        timeout: dynamicTimeout,
                    });


                    this.$emit('setLoadingBookingDialog', false);

                    this.$emit("getAvailability");
                });
        },
        cancelBooking() {
            this.$emit('setBookingPopupData', null);
        },
        openCheckoutDialog(stripeClientSecret) {
            this.$emit('openCheckoutDialog', stripeClientSecret);
        },
    },
    mounted: function () {
        // https://bootstrap-vue.org/docs/components/modal#comp-ref-b-modal-events
        this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
            if (modalId == 'resource-booking-popup') {
                this.selectedService = this.service;
            }
        });

        this.$root.$on('bv::modal::shown', (bvEvent, modalId) => {
            console.log(bvEvent);
            console.log("this.$refs.resourceBookingPopup.", this.$refs.resourceBookingPopup);
            console.log("this.$refs.resourceBookingPopup.$refs", this.$refs.resourceBookingPopup.$refs);
            console.log("this.$refs.resourceBookingPopup.$refs.modal", this.$refs.resourceBookingPopup.$refs.modal);

            if (modalId == 'resource-booking-popup' && this.$refs.resourceBookingPopup.$refs.modal) {
                // this.$refs.resourceBookingPopup.$refs.modal.classList.add('modal-fullscreen');
            }
        })
    }
};
</script>
